import { useSelector } from 'react-redux';

import { entitySelectors } from '@store/entity/selectors';
import type { Property } from 'shared-types/Property';

import { useGetSpaSettings } from './useGetSpaSettings';

export function useHideArrivalTimes(): boolean {
  const property = useSelector(entitySelectors.getProperty) as Property | undefined;
  const { data: spaSettings } = useGetSpaSettings(property?.id);
  return spaSettings?.hideArrivalTimes ?? false;
}
